import { render, staticRenderFns } from "./AddComplaints.vue?vue&type=template&id=2638013b&scoped=true"
import script from "./AddComplaints.vue?vue&type=script&lang=js"
export * from "./AddComplaints.vue?vue&type=script&lang=js"
import style0 from "./AddComplaints.vue?vue&type=style&index=0&id=2638013b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2638013b",
  null
  
)

export default component.exports